import { Component, Input, OnInit } from '@angular/core';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-help-searching',
  templateUrl: './help-searching.component.html'
})
export class HelpSearchingComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService, private route: Router) {
  }
  searching_heading;
  searching_desc;
  searching_para1heading;
  searching_para1body;
  searching_para2heading;
  searching_para2body;
  searching_para3heading;
  searching_para3body;
  searching_para4heading;
  searching_para4body;
  // IsRightPanel:boolean;
  @Input() IsRightPanel:boolean=false;
  ngOnInit(): void {
    // this.IsRightPanel=this.commonDataService.showRightPanel.getValue();
    window.scrollTo(0, 0);
   
    this.commonDataService.showLoader.next(true);
    this.gethelpsearchinglabels();
  }
  gethelpsearchinglabels() {

    this.graphQlService.getSearchingLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.searching_heading = labels.filter(x => x.key == "searching_heading").map(y => y.value);
        this.searching_desc = labels.filter(x => x.key == "searching_desc").map(y => y.value);
        this.searching_para1heading = labels.filter(x => x.key == "searching_para1heading").map(y => y.value);
        this.searching_para1body = labels.filter(x => x.key == "searching_para1body").map(y => y.value);
        this.searching_para2heading = labels.filter(x => x.key == "searching_para2heading").map(y => y.value);
        this.searching_para2body = labels.filter(x => x.key == "searching_para2body").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }

}
